import { gql } from '@apollo/client'
import {
  GuildFragment,
  GuildPvPRecordFragment
} from '@src/graphql/fragment/guild'

export default gql`
  query GetBattleDemoGuildWarPvPLeaderboard(
    $walletAddress: String
    $season: String!
  ) {
    getPVPGuildLeaderboard(walletAddress: $walletAddress, season: $season) {
      record {
        leaderboard {
          ...PvPGuildRecord
        }
        userGuildRank {
          guild {
            ...Guild
          }
          rankingIndex
        }
      }
    }
  }
  ${GuildPvPRecordFragment}
  ${GuildFragment}
`
